export const DEFAULT_LANDING_ROUTE = () => {
  const homepage = "/";

  return homepage;
};

export const ERROR_CODES = {
  /* list of error codes that can be part of the api responses */
  VALIDATION_ERRORS: [406],
  REGULAR_ERRORS: [400, 401, 403, 404, 500],
};
